/**
* @name APP adminPanel
* @description
* # name controller --> educatorsCreateController
* # As Controller --> educatorsCreate
*/

export default class educatorsCreateController {
	constructor($scope,ngNotify,UserInfoConstant,educatorsServices,$state) {
        this.ngNotify = ngNotify;
        this.$state = $state;
        this.$scope = $scope;
        this.services = educatorsServices.services
		this.esValido = 0

        this.educator  = { 
            name : null,
            email : null,
            picture : require("../../../../images/no_user.jpg"),
            lastname : null,
			nameAttorney: null,
			gender: null,
			level: null,
            status : true,
            ngNotify : ngNotify,
            services : educatorsServices.services,
            afterSave : true
        }

		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		})
	}

	init(){
		const params = {
			concept_id: this.conceptId
		}

		this.getGenders()
	}

	getGenders(){
		this.genders = [
			{
				id_code: 1,
				ds_name: 'femenino'
			},
			{
				id_code: 2,
				ds_name: 'masculino'
			}
		]
    }

	beforeSave(){
		if(this.educator.name === null) {
			this.ngNotify.set('Indique nombre','warn')
			return
		}

		if(this.educator.lastname === null) {
			this.ngNotify.set('Indique apellidos','warn')
			return
		}

		if(this.educator.rut === null && this.esValido === 0) {
			this.ngNotify.set('Rut inválido','warn')
			return
		}

		if(this.educator.email === null) {
			this.ngNotify.set('Indique email','warn')
			return
		}

		if(this.educator.nameAttorney === null) {
			this.ngNotify.set('Indique nombre apoderado','warn')
			return
		}
		
		if(this.educator.gender === null) {
			this.ngNotify.set('Indique género','warn')
			return
		}

		this.$scope.isDisabled = true;
		let params  = { 
			name   : this.educator.name,
			ds_last_name   : this.educator.lastname,
			ds_rut   : this.educator.rut,
			ds_name_attorney: this.educator.nameAttorney,
			user_id : this.user_id,
			concept_id: this.conceptId,
			gender_id: this.educator.gender,
			ds_mail: this.educator.email
		}

		this.saveEducator(params)
	}

	validarRut(rut) {
		console.log('rut ::: ', rut)
		if(rut === undefined || rut.length < 9 || !rut.includes('-')) { 
			this.ngNotify.set('Ingrese Rut','warn')
			return
		}
		rut = rut.toUpperCase()
		rut = rut.trim().split('-')

		const rutString = this.validarString(rut[0])
		const dvr = this.validarString(rut[1])
		let largo = rutString.length;
		let factor = 2;
		let caracter = 0;
		let suma = 0;
		let cdv = '123456789K0';

		while (largo !== 0) {
			caracter = parseInt(rutString.charAt(largo - 1), 10);
			suma = suma + (caracter * factor);
			largo = largo - 1;
			factor = factor + 1;
			if (factor === 8) {
				factor = 2;
			}
		}

		let dv = 11 - (suma % 11)
		this.esValido = (cdv.charAt(dv - 1) === dvr) ? 1 : 0

		if(this.esValido) {
			this.ngNotify.set('Rut válido','success')
		} else {
			this.ngNotify.set('Rut inválido','warn')
		}

		return
	}

	validarString(cadena) {
		let resultado = cadena.trim()
		resultado = resultado.replace(/[^a-zA-Z0-9]/g, '')
	  
		return resultado;
	}
			
	saveEducator(params){
		this.$scope.educatorsCreate.educator.isDisabled=true
		this.services.saveEducators(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha creado el docente correctamente','success');
				this.$state.go("app.educators");
			}else{
				this.ngNotify.set('Error , con el servicio','error');
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
			this.$scope.isDisabled = false;
		})
	}
}

educatorsCreateController.$inject=['$scope','ngNotify','UserInfoConstant','educatorsServices', '$state']



// WEBPACK FOOTER //
// ./src/app/admin-panel/educators/create/educatorsCreateController.js